import { z } from 'zod';
import type { AxiosInstance } from 'axios';
import type { PageDetail } from '@trinity/management-app-client';
import { PageDetailSchema } from '@trinity/management-app-client';
import type { CanonicalWidgetData } from '../types/dashboard-data.js';
import { CanonicalWidgetDataSchema } from '../types/dashboard-data.js';

const ProjectDashboardPageSchema = z.object({ pageId: z.number().nullable() });
type ProjectDashboardPage = z.infer<typeof ProjectDashboardPageSchema>;

export class PagesClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  getPage = (id: number): Promise<PageDetail> => {
    return this.authenticatedClient
      .get<PageDetail>(`/pages/${id}`)
      .then(res => PageDetailSchema.parse(res.data));
  };

  getProjectDashboardPage = (projectId: number): Promise<ProjectDashboardPage> => {
    return this.authenticatedClient
      .get<ProjectDashboardPage>(`/pages/project-dashboard/${projectId}`)
      .then(res => ProjectDashboardPageSchema.parse(res.data));
  };

  proxyWidgetData = (agentId: number, extensionPath: string, brandIdentifier?: string): Promise<CanonicalWidgetData> => {
    return this.authenticatedClient
      .post('/pages/widget-data-proxy', { agentId, extensionPath, brandIdentifier })
      .then(res => CanonicalWidgetDataSchema.parse(res.data) as CanonicalWidgetData);
  };
}
